import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventorymanage',
  templateUrl: './inventorymanage.component.html',
  styleUrls: ['./inventorymanage.component.scss']
})
export class InventorymanageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
